module.exports = __webpack_public_path__ + "img/unprotected-sex-icon.dfc7116f.svg";